// ShareFormSection.jsx
import React, { useRef, useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import logoSrc from "./assets/ecologo.png";
import { FaRegCopy } from "react-icons/fa6";
import { BsDownload } from "react-icons/bs";
import "./ShareFormSection.css";

const ShareFormSection = ({
  eventId,
  eventName,
  showMode = "both", // "both" | "link" | "qr"
  hideIntro = false, // new!
}) => {
  const link = `https://ecoindex.ai/add-information?id=${eventId}`;
  const canvasRef = useRef();
  const [toast, setToast] = useState(false);
  const [generatedImageUrl, setGeneratedImageUrl] = useState("");
  const generateImage = () => {
    const qrCanvas = canvasRef.current.querySelector("canvas");

    const qrDataUrl = qrCanvas.toDataURL("image/png", 1.0);

    const finalCanvas = document.createElement("canvas");
    finalCanvas.width = 850 * 2;
    finalCanvas.height = 1200 * 2;
    const ctx = finalCanvas.getContext("2d");

    ctx.scale(2, 2);

    const gradient = ctx.createLinearGradient(
      0,
      0,
      finalCanvas.width / 2,
      finalCanvas.height / 2
    );
    gradient.addColorStop(0, "#f0f8ff");
    gradient.addColorStop(1, "#e0f7fa");
    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, finalCanvas.width / 2, finalCanvas.height / 2);

    // ctx.lineWidth = 5;
    // ctx.strokeStyle = "#007272";
    // ctx.strokeRect(
    //   20,
    //   20,
    //   finalCanvas.width / 2 - 40,
    //   finalCanvas.height / 2 - 40
    // );

    ctx.font = '32px "Montserrat", sans-serif';
    ctx.fillStyle = "#007272";
    ctx.textAlign = "center";
    ctx.font = 'italic 28px "Montserrat", sans-serif';
    ctx.fillText(
      "Please scan and share your details to",
      finalCanvas.width / 4,
      175
    );
    ctx.fillText("track carbon emissions for", finalCanvas.width / 4, 225);

    const ToFitText = (
      context,
      text,
      x,
      y,
      maxWidth,
      initialFontSize,
      minFontSize,
      lineHeight
    ) => {
      let fontSize = initialFontSize;
      context.font = `bold ${fontSize}px "Lora", serif`;
      let textWidth = context.measureText(text).width;

      while (textWidth > maxWidth && fontSize > minFontSize) {
        fontSize -= 2;
        context.font = `bold ${fontSize}px "Lora", serif`;
        textWidth = context.measureText(text).width;
      }

      if (textWidth > maxWidth) {
        const words = text.split(" ");
        let line = "";
        let newY = y;

        for (let i = 0; i < words.length; i++) {
          const testLine = line + words[i] + " ";
          const testWidth = context.measureText(testLine).width;
          if (testWidth > maxWidth && i > 0) {
            context.fillText(line, x, newY);
            line = words[i] + " ";
            newY += lineHeight;
          } else {
            line = testLine;
          }
        }
        context.fillText(line, x, newY);
      } else {
        context.fillText(text, x, y);
      }
    };

    ToFitText(
      ctx,
      eventName,
      finalCanvas.width / 4,
      325,
      finalCanvas.width / 2 - 80,
      80,
      40,
      30
    );

    ctx.font = '40px "Montserrat", sans-serif';
    ctx.fillStyle = "#007272";

    const qrSize = 400;
    const qrX = (finalCanvas.width / 2 - qrSize) / 2;
    const qrY = (finalCanvas.height / 2 - qrSize) / 1.8;
    const radius = 30;
    ctx.lineWidth = 5;
    ctx.strokeStyle = "#007272";
    ctx.beginPath();
    ctx.moveTo(20 + radius, 20);
    ctx.lineTo(finalCanvas.width / 2 - 20 - radius, 20);
    ctx.quadraticCurveTo(
      finalCanvas.width / 2 - 20,
      20,
      finalCanvas.width / 2 - 20,
      20 + radius
    );
    ctx.lineTo(
      finalCanvas.width / 2 - 20,
      finalCanvas.height / 2 - 20 - radius
    );
    ctx.quadraticCurveTo(
      finalCanvas.width / 2 - 20,
      finalCanvas.height / 2 - 20,
      finalCanvas.width / 2 - 20 - radius,
      finalCanvas.height / 2 - 20
    );
    ctx.lineTo(20 + radius, finalCanvas.height / 2 - 20);
    ctx.quadraticCurveTo(
      20,
      finalCanvas.height / 2 - 20,
      20,
      finalCanvas.height / 2 - 20 - radius
    );
    ctx.lineTo(20, 20 + radius);
    ctx.quadraticCurveTo(20, 20, 20 + radius, 20);
    ctx.closePath();
    ctx.stroke();

    ctx.shadowColor = "rgba(0, 0, 0, 0.2)";
    ctx.shadowBlur = 10;
    ctx.shadowOffsetX = 5;
    ctx.shadowOffsetY = 5;

    const qrImage = new Image();
    qrImage.src = qrDataUrl;
    qrImage.onload = () => {
      ctx.drawImage(qrImage, qrX, qrY, qrSize, qrSize);

      const logoImage = new Image();
      logoImage.src = logoSrc;
      logoImage.onload = () => {
        const logoWidth = 140;
        const logoHeight = 60;
        const logoX = 50;
        const logoY = 50;
        ctx.drawImage(logoImage, logoX, logoY, logoWidth, logoHeight);

        ctx.textAlign = "center";
        ctx.font = '28px "Montserrat", sans-serif';
        ctx.fillStyle = "#007272";
        ctx.fillText(
          "Thank you for your contribution!",
          finalCanvas.width / 4,
          qrY + qrSize + 80
        );

        const finalDataUrl = finalCanvas.toDataURL("image/png");
        setGeneratedImageUrl(finalDataUrl);
        const downloadLink = document.createElement("a");
        downloadLink.href = finalDataUrl;
        downloadLink.download = `Add Information: ${eventName}.png`;
        downloadLink.click();
      };
    };
  };
  const copyLink = () => {
    navigator.clipboard.writeText(link).then(() => {
      setToast(true);
      setTimeout(() => setToast(false), 3_000);
    });
  };

  return (
    <div className="share-form-section mb-4">
      {/* {hideIntro && (
        <>
          <h2>Share Attendee Form</h2>
          <p className="text-muted">
            Use these buttons to give your attendees the form:
            <ul>
              <li>
                <strong>Download QR Code</strong> — displays a printable QR that
                links to the form
              </li>
              <li>
                <strong>Copy Link</strong> — copies the form’s URL for email or
                chat
              </li>
            </ul>
          </p>
        </>
      )} */}
      <div ref={canvasRef} className="d-flex gap-2">
        <QRCodeCanvas
          value={link}
          size={128}
          level="M"
          includeMargin={true}
          style={{ display: "none" }}
        />
        {(showMode === "both" || showMode === "qr") && (
          <button className="downloadQR-button" onClick={generateImage}>
            <BsDownload className="download-icon" /> QR Code
          </button>
        )}
        {(showMode === "both" || showMode === "link") && (
          <button className="copy-button" onClick={copyLink}>
            <FaRegCopy className="copy-icon" /> Link
          </button>
        )}
      </div>
      {toast && (
        <div className="toast show position-fixed bottom-0 end-0 m-3">
          Link copied!
        </div>
      )}
    </div>
  );
};

export default ShareFormSection;
